import styled from 'styled-components';
import { darkColors } from '@tryhackme/thm-ui-components';

export const StyledVideoPremium = styled.div`
  background: ${({ theme }) => theme.colors.gradientDark};
  box-shadow: 0px 3px 13px 0px rgba(21, 28, 43, 0.6);
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.grey[100]};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.4rem;
  margin: 3rem 0;
  padding: 3.2rem;

  a {
    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.grey[100]};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledInfo = styled.div`
  align-items: center;
  background-color: ${darkColors.info.lightest};
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  gap: 0.8rem;
  grid-column: 1/-1;
  padding: 1.8rem;

  svg {
    height: 1.6rem;
    width: 1.6rem;

    path {
      fill: ${darkColors.error.main};
    }
  }
`;

export const StyledBenefitsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: end;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: space-between;
    justify-items: start;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
  }

  svg {
    width: auto;
  }

  & > div {
    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: 2rem;
    }
  }
`;

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.grey[100]};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin-bottom: 2.4rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;
